import React from 'react'

import { Area, AreaChart, Tooltip, XAxis, YAxis } from 'recharts'

type PropsType = {
  data: number[]
  className?: string
  width?: number
  height?: number
}

export const Chart = ({ width = 140, height = 50, ...props }: PropsType) => {
  const data = props.data.map(item => ({
    result: item,
  }))

  return (
    <AreaChart
      className={props.className ? props.className : ''}
      width={width}
      height={height}
      data={data}
      margin={{
        top: 10,
        right: 0,
        left: 0,
        bottom: 0,
      }}
    >
      <YAxis
        mirror={true}
        orientation={'left'}
        tickSize={4}
        tickCount={2}
        style={{ fontSize: '12px', fontFamily: 'inherit' }}
      />
      <XAxis mirror={true} tick={false} />

      <Tooltip
        wrapperStyle={{ fontSize: '12px' }}
        formatter={(value, name, props) => [value, 'Результат']}
      />
      <Area
        type="basis"
        dataKey="result"
        stroke="#8884d8"
        fill="#3bb98a"
        style={{ fillOpacity: '1' }}
      />
    </AreaChart>
  )
}
